const basketActions = document.querySelectorAll('.js-basket-actions')
const basketForm = document.getElementById('js-basket-form')

if (basketActions.length) {
  basketActions.forEach((action) => {
    const input = action.querySelector('input')

    input.addEventListener('change', () => {
      basketForm.submit()
    })

    const removeButton = action.querySelector('.basket-products__remove')
    if (removeButton) {
      removeButton.addEventListener('click', () => {
        input.value = 0
        basketForm.submit()
      })
    }

    const minusButton = action.querySelector(
      '.add-to-basket__amount-btn:first-of-type'
    )
    minusButton.addEventListener('click', () => {
      input.value = parseInt(input.value) - 1
      basketForm.submit()
    })

    const plusButton = action.querySelector(
      '.add-to-basket__amount-btn:last-of-type'
    )
    plusButton.addEventListener('click', () => {
      input.value = parseInt(input.value) + 1
      basketForm.submit()
    })
  })

  const country = document.getElementById('del_country_id')
  if (country) {
    if (!localStorage.getItem('country')) {
      country.options[0].selected = true
    }

    country.addEventListener('change', (e) => {
      localStorage.setItem('country', e.target.value)
      basketForm.submit()
    })
  }
}

const voucherTriggers = document.querySelectorAll('.basket__voucher-trigger')
const voucherContent = document.querySelector('.basket__voucher-content')
voucherTriggers.forEach((trigger) => {
  trigger.addEventListener('click', () => {
    voucherContent.classList.toggle('basket__voucher-content--active')
  })
})
